import React from 'react';
import { captureError } from '../../utils/errors';

interface AnalyticsState {
  readonly fromCampaign?: string;
  readonly fromOrigin?: string;
  readonly fromID?: string;
  readonly fromType?: string;
  readonly fromName?: string;
  readonly fromNRIC?: string;
  readonly fromMobilePrefix?: string;
  readonly fromMobile?: string;
  readonly fromEmail?: string;
  readonly campaignEndDate?: string;
}

interface AnalyticsActions {
}

export interface IAnalyticsContext {
  state: AnalyticsState;
  actions: AnalyticsActions;
}

const initialState: AnalyticsState = {
};

export const AnalyticsContext = React.createContext<IAnalyticsContext>({
  state: initialState,
  actions: {},
});

export const AnalyticsContextConsumer = AnalyticsContext.Consumer;
export const AnalyticsContextProvider = AnalyticsContext.Provider;

interface IAnalyticsProviderProps {
  children: React.ReactNode;
}

interface IAnalyticsProviderState {
  readonly data: AnalyticsState;
}

export default class AnalyticsProvider extends
  React.Component<IAnalyticsProviderProps, IAnalyticsProviderState> {
  constructor(props: IAnalyticsProviderProps) {
    super(props);
    this.state = {
      data: initialState,
    };
  }

  async componentDidMount() {
    await this.receiveFrom();
  }

  setStateAsync = (state: IAnalyticsProviderState): Promise<void> => new Promise((res) => {
    this.setState(state, res);
  });

  async receiveFrom() {
    const urlParams = new URLSearchParams(window.location.search);
    const from = urlParams.get('from');

    if (from) {
      try {
        const dataString = atob(from);
        const d = JSON.parse(dataString);
        const { data } = this.state;
        await this.setStateAsync({
          data: {
            ...data,
            fromCampaign: d.campaign,
            fromID: d.id,
            fromOrigin: d.origin,
            fromType: d.type,
            fromName: d.name,
            fromNRIC: d.nric,
            fromEmail: d.email,
            fromMobilePrefix: d.mobilePrefix,
            fromMobile: d.mobile,
            campaignEndDate: d.campaignEndAt
          },
        });
      } catch (err) {
        captureError(err);
      }
    }
  }

  render() {
    const { data } = this.state;
    const { children } = this.props;

    const value: IAnalyticsContext = {
      actions: {},
      state: data,
    };

    return (
      <AnalyticsContextProvider
        value={value}
      >
        {children}
      </AnalyticsContextProvider>
    );
  }
}
